import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { ref } from "vue";

import TextInput from "./TextInput.vue";
import { dateRule, requiredRule } from "@/utils/rules";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateInput',
  props: { modelValue: null, label: String },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;




const showCalendar = ref<boolean>(false);
const maxDate = new Date();

function validateAndFormatBirthDate(inputDate: string) {
  // Remove non-digit characters
  const cleanDate = inputDate.replace(/\D/g, "");

  // Use regex to validate and format as MM/DD/YYYY
  const formattedDate = cleanDate.replace(
    /^(\d{2})(\d{2})(\d{4})$/,
    (match, p1, p2, p3) => {
      // Check if the date components are valid
      const month = parseInt(p1, 10);
      const day = parseInt(p2, 10);
      const year = parseInt(p3, 10);

      if (month >= 1 && month <= 12 && day >= 1 && day <= 31 && year >= 1900) {
        // Format the date as MM/DD/YYYY
        return `${p1}/${p2}/${p3}`;
      } else {
        // Invalid date, return the original input
        return inputDate;
      }
    }
  );

  return formattedDate;
}

function formatDate(date: Date | undefined | string): string {
  if (!date) return "";
  else if (date instanceof Date) return date.toLocaleDateString("en-US");
  else {
    return validateAndFormatBirthDate(date);
  }
  // return date ? date.toLocaleDateString("en-US") : "";
}

function closeDatePicker() {
  showCalendar.value = false;
}

const calendarDate = computed({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get: (): any => (props.modelValue ? new Date(props.modelValue) : undefined),
  set: (date): void => emit("update:modelValue", formatDate(date)),
});

return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_menu, {
      modelValue: showCalendar.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showCalendar).value = $event)),
      "close-on-content-click": false,
      transition: "scale-transition"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(TextInput, _mergeProps({
          modelValue: formatDate(calendarDate.value),
          label: __props.label,
          icon: "mdi-calendar",
          rules: [_unref(dateRule), _unref(requiredRule)]
        }, props, {
          "date-validation": true,
          readonly: true,
          placeholder: " ",
          required: ""
        }), null, 16, ["modelValue", "label", "rules"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_date_picker, {
          color: "primary",
          modelValue: calendarDate.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((calendarDate).value = $event)),
            closeDatePicker
          ],
          max: _unref(maxDate)
        }, null, 8, ["modelValue", "max"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})